import { ArrowPathIcon, ClockIcon } from '@heroicons/react/20/solid';
import { ActionButton } from '../../../../components/buttons/ActionButton';
import { GroupButton } from '../../../../components/buttons/GroupButton';
import { DateRangePickerComponent } from '../../../../components/others/DateRangePickerComponent';
import {
  getVeralliaDashboardAvailableDefects,
  getVeralliaDashboardAvailableLines,
  getVeralliaDashboardDefaultFilters,
  getVeralliaDashboardPeriodRange,
} from '../../../../services/dashboard/verallia-dashboard-service';

const toggleArrayValue = (values, value) => {
  return values.includes(value) ? values.filter((currentValue) => currentValue !== value) : [...values, value];
};

export const VeralliaDashboardFilters = ({ detections, value, onChange }) => {
  const availableLines = getVeralliaDashboardAvailableLines(detections);
  const availableDefects = getVeralliaDashboardAvailableDefects(detections);
  const activeFilterCount = (value.lines.length > 0 ? 1 : 0) + (value.defects.length > 0 ? 1 : 0);

  const handleRangeShortcut = (rangeKey) => {
    onChange({ ...value, ...getVeralliaDashboardPeriodRange(rangeKey, detections) });
  };

  const handleCustomRange = (start, end) => {
    onChange({
      ...value,
      start: Math.floor(start.getTime() / 1000),
      end: Math.floor(end.getTime() / 1000),
      rangeKey: 'custom',
    });
  };

  const handleReset = () => {
    onChange(getVeralliaDashboardDefaultFilters(detections));
  };

  const selectedRangeIndex = ['last_24h', 'last_7d', 'last_30d', 'all'].indexOf(value.rangeKey);

  return (
    <div className="rounded-md bg-perception-black-500 p-4">
      <div className="flex flex-col gap-4">
        <div className="flex items-start justify-between gap-8">
          <div className="flex flex-col gap-2">
            <div className="text-xs font-semibold uppercase text-perception-gray-600">Línea</div>

            <div className="flex flex-wrap gap-2">
              {availableLines.map((linea) => {
                const isSelected = value.lines.includes(linea);

                return (
                  <ActionButton
                    key={linea}
                    text={linea}
                    color={isSelected ? 'primary' : 'secondary'}
                    size="sm"
                    onClick={() => onChange({ ...value, lines: toggleArrayValue(value.lines, linea) })}
                  />
                );
              })}
            </div>
          </div>

          <div className="flex items-center gap-3 text-xs uppercase text-perception-gray-600">
            <span>{activeFilterCount} {activeFilterCount === 1 ? 'filtro activo' : 'filtros activos'}</span>
            <ActionButton text="Restablecer" Icon={ArrowPathIcon} color="secondary" size="sm" onClick={handleReset}/>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <div className="text-xs font-semibold uppercase text-perception-gray-600">Defecto</div>

          <div className="flex flex-wrap gap-2">
            {availableDefects.map((defect) => {
              const isSelected = value.defects.includes(defect.id);

              return (
                <ActionButton
                  key={defect.id}
                  text={defect.name}
                  color={isSelected ? 'primary' : 'secondary'}
                  size="sm"
                  onClick={() => onChange({ ...value, defects: toggleArrayValue(value.defects, defect.id) })}
                />
              );
            })}
          </div>
        </div>

        <div className="flex flex-wrap items-end gap-4">
          <div className="flex flex-col gap-2">
            <div className="text-xs font-semibold uppercase text-perception-gray-600">Período</div>

            <GroupButton
              selected={selectedRangeIndex >= 0 ? selectedRangeIndex : null}
              size="sm"
              buttons={[
                { text: 'Últimas 24 horas', color: value.rangeKey === 'last_24h' ? 'primary' : 'secondary', onClick: () => handleRangeShortcut('last_24h') },
                { text: 'Últimos 7 días', color: value.rangeKey === 'last_7d' ? 'primary' : 'secondary', onClick: () => handleRangeShortcut('last_7d') },
                { text: 'Últimos 30 días', color: value.rangeKey === 'last_30d' ? 'primary' : 'secondary', onClick: () => handleRangeShortcut('last_30d') },
                { text: 'Todo el histórico', color: value.rangeKey === 'all' ? 'primary' : 'secondary', onClick: () => handleRangeShortcut('all') },
              ]}
            />
          </div>

          <DateRangePickerComponent
            key={`${value.start}-${value.end}`}
            defaultStart={new Date(value.start * 1000)}
            defaultEnd={new Date(value.end * 1000)}
            callback={handleCustomRange}
            validateText="Aplicar"
            cancelText="Cancelar"
            trigger={({ isCalendarOpen, setIsCalendarOpen }) => (
              <ActionButton
                text="Rango personalizado"
                Icon={ClockIcon}
                color={value.rangeKey === 'custom' ? 'primary' : 'secondary'}
                size="sm"
                onClick={() => setIsCalendarOpen(!isCalendarOpen)}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};